export enum backgroundEnum {
    default = '',
    whiteBis = 'has-background-white-bis',
    whiteTer = 'has-background-white-ter',
    greyLighter = 'has-background-grey-lighter',
    greyLight = 'has-background-grey-light',
    grey = 'has-background-grey',
    greyDark = 'has-background-grey-dark',
    greyDarker = 'has-background-grey-darker',
    blackTer = 'has-background-black-ter',
    blackBis = 'has-background-black-bis',
    danger = 'has-background-danger',
    warning = 'has-background-warning',
    success = 'has-background-success',
    link = 'has-background-link',
    info = 'has-background-info',
    primary = 'has-background-primary',
    white = 'has-background-white',
    black = 'has-background-black',
    light = 'has-background-light',
    dark = 'has-background-dark',
}

export type Background = backgroundEnum.default | backgroundEnum.white | backgroundEnum.whiteBis | backgroundEnum.whiteTer |
    backgroundEnum.greyLighter | backgroundEnum.greyLight | backgroundEnum.grey | backgroundEnum.greyDark |
    backgroundEnum.greyDarker | backgroundEnum.blackTer | backgroundEnum.blackBis | backgroundEnum.danger |
    backgroundEnum.warning | backgroundEnum.success | backgroundEnum.link |backgroundEnum.info |
    backgroundEnum.primary | backgroundEnum.black |backgroundEnum.light | backgroundEnum.dark;


